(function () {
  const DURATION_MS = 300;

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function getGroup(details) {
    const name = details.getAttribute('name');
    if (!name) return [details];

    const root = details.closest('faq-page, .faqs, section') || document;
    return Array.from(root.querySelectorAll(`details.faqs__details[name="${name}"]`));
  }

  function closeDetails(details) {
    const outer = details.querySelector('.faqs__content-outer');
    const summary = details.querySelector('summary');

    if (!details.open && !details.classList.contains('faq-accordion--active')) return;

    if (prefersReducedMotion() || !outer) {
      details.classList.remove('faq-accordion--active', 'faq-accordion--closing');
      details.open = false;
      summary?.setAttribute('aria-expanded', 'false');
      return;
    }

    if (details.classList.contains('faq-accordion--closing')) return;

    details.classList.add('faq-accordion--closing');
    details.classList.remove('faq-accordion--active');

    let finished = false;
    const finish = () => {
      if (finished) return;
      finished = true;
      outer.removeEventListener('transitionend', onTransitionEnd);
      details.classList.remove('faq-accordion--closing');
      details.open = false;
      summary?.setAttribute('aria-expanded', 'false');
    };

    const onTransitionEnd = (event) => {
      if (event.target !== outer) return;
      finish();
    };

    outer.addEventListener('transitionend', onTransitionEnd);
    window.setTimeout(finish, DURATION_MS + 50);
  }

  function openDetails(details) {
    const outer = details.querySelector('.faqs__content-outer');
    const summary = details.querySelector('summary');

    details.open = true;
    summary?.setAttribute('aria-expanded', 'true');

    if (prefersReducedMotion() || !outer) {
      details.classList.add('faq-accordion--active');
      return;
    }

    details.classList.remove('faq-accordion--closing');
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        details.classList.add('faq-accordion--active');
      });
    });
  }

  function openExclusive(details) {
    getGroup(details).forEach((other) => {
      if (other !== details && (other.open || other.classList.contains('faq-accordion--active'))) {
        closeDetails(other);
      }
    });
    openDetails(details);
  }

  function onSummaryClick(event) {
    const summary = event.currentTarget;
    const details = summary.closest('.faqs__details');
    if (!details) return;

    event.preventDefault();

    if (details.classList.contains('faq-accordion--closing')) return;

    const isActive =
      details.classList.contains('faq-accordion--active') && details.open;

    if (isActive) {
      closeDetails(details);
    } else {
      openExclusive(details);
    }
  }

  function initDetails(details) {
    if (details.dataset.faqAccordionBound) return;
    details.dataset.faqAccordionBound = 'true';

    const summary = details.querySelector('summary');
    const outer = details.querySelector('.faqs__content-outer');
    if (!summary || !outer) return;

    if (details.hasAttribute('open') || details.classList.contains('faq-accordion--active')) {
      details.open = true;
      details.classList.add('faq-accordion--active');
      summary.setAttribute('aria-expanded', 'true');
    } else {
      details.open = false;
      summary.setAttribute('aria-expanded', 'false');
    }

    summary.addEventListener('click', onSummaryClick);
  }

  function initAll(root) {
    const scope = root && root.nodeType === 1 ? root : document;
    scope.querySelectorAll('.faqs__details').forEach(initDetails);
  }

  document.addEventListener('DOMContentLoaded', () => initAll());
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
